"use client";
import { createContext as e, useContext as t } from "react";
import { xoroshiro128plus as n } from "pure-rand/generator/xoroshiro128plus";
//#region src/core/currency.ts
var r = {
	name: "credit",
	namePlural: "credits",
	symbol: "$",
	multiplier: 100,
	iconSvg: ""
};
function i(e) {
	switch (e) {
		case 1: return 0;
		case 10: return 1;
		case 100: return 2;
		case 1e3: return 3;
	}
}
var a = [
	0,
	1,
	2,
	3
].map((e) => new Intl.NumberFormat("en-US", {
	minimumFractionDigits: e,
	maximumFractionDigits: e
}));
function o(e, t, n = {}) {
	if (!Number.isFinite(e)) throw RangeError(`formatAmount: amount is not a finite number of cents: ${e}`);
	let r = i(t.multiplier), o = Math.abs(e) / t.multiplier, s = e < 0 ? "-" : "", c = n.compact && o >= 1e3 ? `${(o / 1e3).toFixed(1)}k` : a[r].format(o);
	return `${s}${t.symbol}${c}`;
}
function s(e, t) {
	return e === t.multiplier ? t.name : t.namePlural;
}
function c(e, t) {
	let n = o(e, t);
	return t.symbol === "" ? `${n} ${s(e, t)}` : n;
}
//#endregion
//#region src/i18n/strings.ts
var l = {
	open: "Open",
	openAgain: "Open again",
	skip: "Skip",
	quantity: "Quantity",
	quickReveal: "Quick reveal",
	claim: "Claim items",
	claiming: "Claiming…",
	sellBack: "Sell back",
	sellingBack: "Selling back…",
	errorSellBackFailed: "Selling back failed. Please try again.",
	withdrawItem: "Withdraw",
	withdrawRequested: "Withdrawal started",
	limitedItemNotice: "Limited item. If you cannot withdraw it, you keep it and can sell it for its value.",
	substituteBadge: "Cannot be shipped",
	autoClaimLabel: "Auto-claim future opens",
	errorClaimFailed: "Claiming failed. Please try again.",
	totalValue: "Total value",
	loading: "Loading…",
	demoBadge: "Demo",
	errorGeneric: "Something went wrong. Please try again.",
	errorInsufficientBalance: "Not enough balance to open this box.",
	errorAccountLocked: "This account is locked. Contact support.",
	provablyFair: "Provably fair",
	serverSeedHash: "Server seed hash",
	clientSeed: "Client seed",
	salt: "Salt",
	seedDate: "Seed date",
	nonce: "Nonce",
	result: "Result",
	noOpensYet: "Open the box to record provably-fair rolls here.",
	battleStartsIn: "Battle starts in",
	battleGoodLuck: "Good luck!",
	battleGo: "GO",
	battleRound: "Round"
};
function u(e) {
	return e ? {
		...l,
		...e
	} : l;
}
//#endregion
//#region ../api-contract/src/storefrontThemeVars.ts
var d = /^(#[0-9a-fA-F]{3,8}|(?:oklch|rgba?|hsla?)\([0-9a-zA-Z.%,/\s+-]+\)|[a-zA-Z]{3,20})$/, f = /^(\d{1,3}(?:\.\d+)?)(px|rem|em|%)?$/, p = /^[\w\s,'"-]{1,100}$/;
function m(e) {
	let t = e?.trim() ?? "";
	return t && d.test(t) ? t : null;
}
function h(e) {
	let t = f.exec(e?.trim() ?? "");
	return t ? t[2] ? t[0] : `${t[1]}px` : null;
}
function g(e) {
	let t = e?.trim() ?? "";
	return t && p.test(t) ? t : null;
}
//#endregion
//#region ../api-contract/src/svgIcon.ts
function _(e) {
	return `data:image/svg+xml,${encodeURIComponent(e)}`;
}
//#endregion
//#region src/theme/rarity.ts
var v = {
	0: "179,179,179",
	1: "34,197,94",
	2: "59,130,246",
	3: "168,85,247",
	4: "249,115,22",
	5: "249,115,22"
}, y = {
	0: "#A9A9CA",
	1: "#22C55E",
	2: "#3B82F6",
	3: "#A855F7",
	4: "#FFC700",
	5: "#FFC700"
}, b = "#FFFFFF";
function x(e, t, n, r) {
	return `drop-shadow(0 0 ${n} rgba(${e[t] || "255,255,255"},${r}))`;
}
function S(e, t) {
	switch (t) {
		case 0: return x(e, t, "15px", "0.3");
		case 1: return x(e, t, "15px", "0.4");
		case 2: return x(e, t, "15px", "0.7");
		case 3:
		case 4:
		case 5: return x(e, t, "15px", "1");
		default: return x(e, t, "15px", "1");
	}
}
function C(e, t) {
	return t == null ? b : e[t] ?? "#FFFFFF";
}
//#endregion
//#region src/theme/theme.ts
var w = {
	background: "#0e0f1a",
	surface: "#131420",
	border: "#2a2b3d",
	text: "#ffffff",
	textMuted: "#a9a9ca",
	accent: "#8b5cf6",
	accentForeground: "#ffffff"
};
function T(e) {
	let t = e.trim();
	if (/^\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}$/.test(t)) return t.replace(/\s+/g, "");
	let n = t.match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i)?.[1];
	if (n) {
		let e = n.length === 3 ? n.replace(/./g, (e) => e + e) : n;
		return `${Number.parseInt(e.slice(0, 2), 16)},${Number.parseInt(e.slice(2, 4), 16)},${Number.parseInt(e.slice(4, 6), 16)}`;
	}
	let r = t.match(/^rgba?\(\s*(\d{1,3})\s*[, ]\s*(\d{1,3})\s*[, ]\s*(\d{1,3})/i);
	return r ? `${r[1]},${r[2]},${r[3]}` : null;
}
function E(e) {
	let [t = 0, n = 0, r = 0] = e.split(",").map((e) => Number.parseInt(e, 10)), i = (e) => Math.max(0, Math.min(255, e)).toString(16).padStart(2, "0");
	return `#${i(t)}${i(n)}${i(r)}`;
}
var D = [
	0,
	1,
	2,
	3,
	4,
	5
], O = /^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/i, k = /^[a-z][a-zA-Z0-9]{0,31}$/;
function A(e) {
	let t = {
		...w,
		...e?.colors
	}, n = { ...v }, r = { ...y };
	for (let t of D) {
		let i = e?.rarity?.[t];
		if (!i) continue;
		let a = T(i);
		a && (n[t] = a, r[t] = E(a));
	}
	let i = {};
	for (let [t, n] of Object.entries(e?.kind ?? {})) k.test(t) && typeof n == "string" && O.test(n) && (i[t] = n);
	return {
		cssVars: {
			"--los-bg": t.background,
			"--los-surface": t.surface,
			"--los-border": t.border,
			"--los-text": t.text,
			"--los-text-muted": t.textMuted,
			"--los-accent": t.accent,
			"--los-accent-foreground": t.accentForeground,
			"--los-radius": e?.radius ?? "16px",
			"--los-font": e?.fontFamily ?? "inherit",
			...Object.fromEntries(Object.entries(i).map(([e, t]) => [`--los-kind-${e}`, t]))
		},
		colors: t,
		rarityRgb: n,
		railHex: r,
		kind: i
	};
}
function j(e, t) {
	if (!t) return e;
	let n = { ...e?.colors };
	for (let [e, r] of Object.entries(t.colors ?? {})) {
		let t = typeof r == "string" ? m(r) : null;
		t && (n[e] = t);
	}
	let r = { ...e?.rarity };
	for (let e of D) {
		let n = t.rarity?.[String(e)], i = typeof n == "string" ? m(n) : null;
		i && (r[e] = i);
	}
	let i = h(t.radius) ?? e?.radius, a = g(t.fontFamily) ?? e?.fontFamily, o = {
		...e?.kind,
		...t.kind
	};
	return {
		...Object.keys(n).length ? { colors: n } : {},
		...Object.keys(r).length ? { rarity: r } : {},
		...i ? { radius: i } : {},
		...a ? { fontFamily: a } : {},
		...Object.keys(o).length ? { kind: o } : {}
	};
}
function M(e, t) {
	return Object.fromEntries(Object.entries(t).map(([t, n]) => [t, e.kind[t] ?? ("role" in n ? e.colors[n.role] : n.color)]));
}
//#endregion
//#region src/react/LootBoxContext.tsx
var N = () => {}, P = {
	strings: l,
	theme: A(),
	sounds: {
		playTickSound: N,
		playRaritySound: N,
		unlock: N,
		enabled: !1
	},
	currency: r
}, F = e(P);
function I() {
	return t(F);
}
//#endregion
//#region src/core/dropTable.ts
var L = 1e6;
function R(e, t) {
	let n = e / t;
	return n === Infinity ? 0 : n > .7 && n < 1 ? 1 : n >= 1 && n < 1.5 ? 2 : n >= 1.5 && n < 6.5 ? 3 : n >= 6.5 ? 4 : 0;
}
function z(e) {
	let t = (e || 0) / L * 100;
	return Number(t.toFixed(4));
}
function B(e, t) {
	let n = 0;
	for (let t = 0; t < e.length; t++) n += e[t]?.weight ?? 0;
	if (n !== 1e6) throw Error(`[loot-os] drop-table weights must sum to ${L}, got ${n}`);
	let r = t;
	for (let t = 0; t < e.length; t++) if (r -= e[t]?.weight ?? 0, r < 0) return t;
}
//#endregion
//#region src/battle/seed.ts
function V(e) {
	let t = 2166136261;
	for (let n = 0; n < e.length; n++) t ^= e.charCodeAt(n), t = Math.imul(t, 16777619);
	return t | 0;
}
function H(e, t = 0) {
	return n(V(e) + t);
}
//#endregion
export { o as C, s as S, _, R as a, r as b, I as c, A as d, y as f, C as g, S as h, z as i, j as l, x as m, V as n, B as o, v as p, L as r, F as s, H as t, M as u, l as v, c as w, i as x, u as y };

//# sourceMappingURL=seed-Bzz9ideE.js.map